
export function validatePasswordMatch({password, confirmPassword}) {
    if (password !== confirmPassword) {
        return "Passwords do not match";
    }
    return null;
}